import { axiosLocal5000Local } from "../axios";


export async function getLiveNewsSentiment(selectedDate:any){
    return await axiosLocal5000Local.post(`/liveOverall/getNewsSentiment`,{"selectedDate": selectedDate})
    .then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching NIFTY50 Spot charts data : ", error)
        return {"error": true}
       
    })
}

